import {FormioBase} from "./formiobase";

export class Classification extends FormioBase {
  public inputType = "classification";
  public title = "Catalogues";
  public icon = "fa fa-list-alt";
  public shouldBeRenderedByFormio = false;
  public schema: any = {
    title: "Catalogues",
    components: [{
      input: true,
      inputType: "classification",
      tableView: true,
      classificationType: "",
      parentClassificationFieldKey: "",
      label: "catalogue",
      key: undefined,
      placeholder: "",
      data: {
        custom: "",
        resource: "",
        url: "",
        json: "",
        values: [],
      },
      dataSrc: "url",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.value }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      validate: {
        required: false,
      },
      type: "select",
      tags: [],
      disabled: false,
      clearOnHide: true,
      description: "",
      calculateValue: "",
      tooltip: "",
      customClass: "ds-classification",
    }],
  };
}
